import { defineComponent, openBlock, createElementBlock, normalizeStyle, createStaticVNode } from 'vue';

const _hoisted_1 = ["fill"];
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity="0.3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle>', 3);
const _hoisted_5 = [
  _hoisted_2
];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Loader",
  props: {
    width: { default: 50 },
    fillColor: { default: "currentColor" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", {
        class: "mx-auto block",
        style: normalizeStyle({ width: `${_ctx.width}px` }),
        viewBox: "0 0 120 30",
        xmlns: "http://www.w3.org/2000/svg",
        fill: _ctx.fillColor
      }, _hoisted_5, 12, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
